import React, { useState } from 'react';

import Header from '../../components/header';
import TimezoneInfo from '../../components/timezoneInfo';
import ReloadButton from '../../components/reloadButton';
import NotificationTools from '../../components/notificationTools';
import WebAnalyticsContainer from '../../containers/features/webAnalytics';
import Loading from '../../components/loading';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPortals, getSelectedPortal } from '../../redux/portal/actions';

const WebEmbedScreen = () => {
  const [lastUpdated, setLastUpdated] = useState('');
  const portals = useSelector(getPortals);
  const selectedPortal = useSelector(getSelectedPortal);

  if (portals === null) {
    return (
      <div className="d-flex flex-fill justify-content-center align-items-center">
        <Loading size={8} />
      </div>
    );
  }

  if (!selectedPortal?.activeFeatures?.includes('WEB_ANALYTICS')) {
    return <Redirect to="/charts" />;
  }

  return (
    <div className="d-flex flex-column flex-fill">
      <Header
        title={'Web Embed'}
        icon={'webAnalytics'}
        actions={[
          { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
          {
            type: 'reactComponent',
            value: <ReloadButton key="reload-btn" contentName="Web Embeds data" lastUpdatedCB={setLastUpdated} />
          },
          { type: 'reactComponent', value: <NotificationTools key="notification-btn" /> }
        ]}
      />
      <WebAnalyticsContainer lastUpdated={lastUpdated} />
    </div>
  );
};

export default WebEmbedScreen;
